<template>
  <section :class="{ 'nav-scroll': scrolled }">
    <div class="navbar" :class="{ transparent }">
      <!-- 국가선택 -->
      <div v-if="nation" name="nation" @click="openedSetSiteInfo = true">
        <!-- 뉴질랜드 -->
        <div v-if="siteCode == $config.SITECODE_OGAUC" class="nation">
          <i class="icon icon-nation-nz" />
          <span class="name">{{ /*오클랜드*/ $t("ogauc_국가명") }}</span>
        </div>
        <!-- 베트남 -->
        <div v-if="siteCode == $config.SITECODE_OGHCM" class="nation">
          <i class="icon icon-nation-vn" />
          <span class="name">{{ /*베트남*/ $t("ogvtn_국가명") }}</span>
        </div>
        <!-- 인도 -->
        <div v-if="siteCode == $config.SITECODE_OGIND" class="nation">
          <i class="icon icon-nation-ind" />
          <span class="name">{{ /*인도*/ $t("ogind_국가명") }}</span>
        </div>
        <!-- 미얀마 -->
        <div v-if="siteCode == $config.SITECODE_OGMMR" class="nation">
          <i class="icon icon-nation-mm" />
          <span class="name">{{ /*미얀마*/ $t("ogmmr_국가명") }}</span>
        </div>
        <!-- 캄보디아 -->
        <div v-if="siteCode == $config.SITECODE_OGCBD" class="nation">
          <i class="icon icon-nation-cam" />
          <span class="name">{{ /*캄보디아*/ $t("ogcbd_국가명") }}</span>
        </div>
      </div>
      <!-- 뒤로가기 -->
      <template v-if="isPersonalUser">
        <!-- 강제 비밀번호 변경 사용자는 전체메뉴 버튼 가림 -->
        <i
          class="icon icon-goback"
          v-if="
            goback &&
              isUserPwdRegiYn != '1' &&
              isUserPwdRegiYn != '2' &&
              isUserPwdRegiYn != '4' &&
              (!isLvbdInfoRegiMandanCustYn || (isLvbdInfoRegiMandanCustYn && isLvbdInfoRegiYn)) &&
              this.sessionInfo.userInfo.mchtlModfiYn != '1'
          "
          @click="actGoBackPage"
        ></i>
      </template>
      <template v-else>
        <i class="icon icon-goback" v-if="goback && isUserPwdRegiYn != '1' && isUserPwdRegiYn != '2' && isUserPwdRegiYn != '4'" @click="actGoBackPage"></i>
      </template>
      <!-- <div v-else>LOGO</div> -->
      <!-- 개발/스테이징 표시 -->
      <router-link :to="{ name: 'motpTest' }" tag="span" v-if="getServer()" style="text-align: center; display: inline-block; width: 50%; background-color: red; font-weight: bold">
        [
        <template v-if="'development|local'.includes(this.server)">{{ server }}</template>
        <template v-else>staging</template>
        ]
      </router-link>
      <template v-if="isPersonalUser">
        <!-- 강제 비밀번호 변경 사용자, 캄보디아(서비스 종료), 개인고객일때 생체정보 등록여부에 따라 전체메뉴 버튼 가림 -->
        <i
          v-if="
            menu &&
              isUserPwdRegiYn != '1' &&
              isUserPwdRegiYn != '2' &&
              isUserPwdRegiYn != '4' &&
              siteCode != $config.SITECODE_OGCBD &&
              (!isLvbdInfoRegiMandanCustYn || (isLvbdInfoRegiMandanCustYn && isLvbdInfoRegiYn)) &&
              this.sessionInfo.userInfo.mchtlModfiYn != '1'
          "
          class="icon icon-all-menu"
          @click="menuOpen = true"
        ></i>
      </template>
      <template v-else>
        <i
          v-if="menu && isUserPwdRegiYn != '1' && isUserPwdRegiYn != '2' && isUserPwdRegiYn != '4' && siteCode != $config.SITECODE_OGCBD"
          class="icon icon-all-menu"
          @click="menuOpen = true"
        ></i>
      </template>
    </div>
    <all-menu v-if="menuOpen" />
    <choose-site-info :opened.sync="openedSetSiteInfo" />
  </section>
</template>
<style lang="scss" scoped></style>
<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import Common from "@/components/basic/Common";
import AllMenu from "@/components/layout/AllMenu";
import ChooseSiteInfo from "@/components/page/main/ChooseSiteInfo";
export default {
  name: "AppBar",
  extends: Common,
  components: { AllMenu, ChooseSiteInfo },
  props: {
    transparent: { type: Boolean, default: false },
    goback: { type: Boolean, default: true },
    nation: { type: [Boolean], default: false },
    home: { type: [Boolean], default: false },
    menu: { type: [Boolean], default: true },
  },
  data() {
    return {
      scrolled: false,
      authPopup: false,
      popupGbn: 0,
      openedSetSiteInfo: false, //국가언어 설정 팝업
      server: process.env.NODE_ENV,
    };
  },
  computed: {
    ...mapFields(["sessionInfo", "menuOpen"]),
    ...mapGetters(["isUserPwdRegiYn", "isLogin", "isLvbdInfoRegiMandanCustYn", "isLvbdInfoRegiYn", "isPersonalUser"]),
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    this.$log.info("scroll start");
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    this.$log.info("scroll end");
  },
  methods: {
    getServer() {
      let isShow = false;
      if ("development|local".includes(this.server)) {
        isShow = true;
      }

      if (location.hostname == "ymkbglobal.kbstar.com") {
        isShow = true;
      }

      return isShow;
    },
    authPopupOpen() {
      this.authPopup = true;
    },
    handleScroll() {
      this.scrolled = window.scrollY > 0;
    },
  },
};
</script>
